import { Box, ButtonBase, makeStyles } from '@material-ui/core';
import React, { useState } from 'react';
import Row from 'src/components/Row';
import COLORS from 'src/lib/colors';
import { Body } from 'src/components/UI';
import GetCodeDrawer from 'src/components/GetCodeDrawer';
import { getUserPasscodeInfo } from 'src/lib/api-client/user-info';
import LoadingOverlay from 'src/components/loading-overlay';
import { useYourFiles } from 'src/lib/contexts/YourFilesContext';
import GetCodeDrawerForScanQr from 'src/components/GetCodeDrawerForScanQr';

const useStyles = makeStyles((theme) => ({
    scanQrBox: {
        padding: '16px',
        borderRadius: '15px',
    },
    openCameraBtn: {
        alignSelf: 'center',
        backgroundColor: COLORS.brandRed,
        color: 'white',
        lineHeight: '2.5rem',
        borderRadius: '2rem',
        width: '116px',
        height: '40px',
        fontWeight: 500,
        fontSize: '0.95rem',
        letterSpacing: '0',
        userSelect: 'none',
    },
    qrBox: {
        width: 53,
        height: 70,
    },
    connectedBox: {
        width: 30,
        height: 30,
    },
    qrImg: {
        height: '30px',
        width: '30px',
    },
    readyToPrint: {
        height: '46px',
        width: '46px',
    },
    scanText: {
        fontSize: 18,
        fontWeight: 500,
        lineHeight: '24px',
        color: '#fff',
    },
    showMeText: {
        fontSize: 14,
        fontWeight: 400,
        lineHeight: '18px',
        color: '#fff',
        textDecoration: 'underline',
    },
}));

export default function ScanQr() {
    const classes = useStyles();
    const { showFileOption } = useYourFiles();
    const [openDrawer, setOpenDrawer] = useState(false);
    const [error, setError] = useState(false);
    const [isConnected, setIsConnected] = useState(false);
    const [retrivePasscode, setRetrivePasscode] = useState(false);
    const [inputValue, setInputValue] = useState('');

    const handleOpenDrawer = async () => {
        setRetrivePasscode(true);
        try {
            const userInfoData = await getUserPasscodeInfo();
            setInputValue(userInfoData?.passcode);
            setOpenDrawer(true);
            setRetrivePasscode(false);
        } catch (errorData) {
            setRetrivePasscode(false);
        }
    };

    const handleAllSet = () => {
        if (
            inputValue &&
            inputValue.length &&
            inputValue.trim() !== '' &&
            inputValue.trim().length === 6
        ) {
            setError(false);
            setOpenDrawer(false);
            setIsConnected(true);
        } else {
            setIsConnected(false);
            setError(true);
        }
    };
    if (retrivePasscode) {
        return <LoadingOverlay open={retrivePasscode} />;
    }
    return isConnected ? (
        <Box
            style={{
                minHeight: 62,
                // height: 142,

                background:
                    'linear-gradient(98deg, #3E009F 0%, #5B0069 153.14%)',
                // boxShadow: ' 0px 5px 4px 0px rgba(0, 0, 0, 0.10)',
                marginBottom: '2px',
                padding: '16px',
            }}
        >
            <Row gap="10px" sx={{ alignItems: 'center' }}>
                <>
                    <Box className={classes.connectedBox}>
                        <img
                            src={require('../../../assets/icons/CheckPrint.svg')}
                            className={classes.qrImg}
                            alt="QR"
                        />
                    </Box>
                    <Body
                        size={16}
                        weight="normal"
                        lineHeight={20}
                        color="textWhite"
                    >
                        You are connected to [p_name].
                    </Body>
                </>
            </Row>
        </Box>
    ) : (
        <Box
            style={{
                minHeight: 142,
                // height: 142,

                background:
                    'linear-gradient(98deg, #3E009F 0%, #5B0069 153.14%)',
                boxShadow: ' 0px 5px 4px 0px rgba(0, 0, 0, 0.10)',
                marginBottom: '2px',
                ...(showFileOption && { opacity: 0.4 }),
            }}
        >
            <Box className={classes.scanQrBox}>
                <Row gap="10px" sx={{ alignItems: 'start', marginTop: '-3px' }}>
                    <>
                        <Box className={classes.qrBox}>
                            <img
                                src={require('../../../assets/icons/readyToPrintNew.svg')}
                                className={classes.readyToPrint}
                                alt="QR"
                            />
                        </Box>
                        <Row direction="column" gap="10px">
                            <>
                                <Row direction="column">
                                    <>
                                        <Body
                                            color={'textWhite'}
                                            size={20}
                                            weight="bold"
                                            lineHeight={26}
                                        >
                                            Ready to print?
                                        </Body>
                                        <Row direction="column">
                                            <>
                                                <Body
                                                    color={'textWhite'}
                                                    size={14}
                                                    lineHeight={18}
                                                    weight="light"
                                                >
                                                    Request a One-Time-Password
                                                    to get
                                                </Body>
                                                <Body
                                                    color={'textWhite'}
                                                    size={14}
                                                    lineHeight={18}
                                                    weight="light"
                                                >
                                                    connected.
                                                </Body>
                                            </>
                                        </Row>
                                    </>
                                </Row>
                                <Row gap="16px" alignItems={'center'}>
                                    <>
                                        <ButtonBase
                                            className={classes.openCameraBtn}
                                            onClick={handleOpenDrawer}
                                        >
                                            Get code
                                        </ButtonBase>
                                    </>
                                </Row>
                            </>
                        </Row>
                    </>
                </Row>
            </Box>

            {openDrawer ? (
                <GetCodeDrawerForScanQr
                    openDrawer={openDrawer}
                    handleCloseDrawer={() => setOpenDrawer(false)}
                    inputValue={inputValue}
                    handleAllSet={handleAllSet}
                    error={error}
                />
            ) : null}
        </Box>
    );
}
